export default __webpack_public_path__ + "static/media/appView.ca837a52.png";